import { ReduxHelper } from "helpers";
import { IPaginationRequest } from "model/Common/IPaginationRequest";
import { IPaginateApiResponse } from "model/Common/IPaginateApiResponse";
import { ILoadingOrder } from "model/LoadingOrder/ILoadingOrder";
import {
  IGetLoadingOrderProductRequest,
  ILoadingOrderProduct,
} from "model/LoadingOrder/ILoadingOrderProduct";
import {
  IDeliveryProgress,
  IGetDeliveryProgressRequest,
} from "model/LoadingOrder/IDeliveryProgress";
import {
  IGetLoadingOrderPalletsRequest,
  IGetRelatedDocumentRequest,
  ILoadingOrderPallet,
  IRelatedDocument,
  IImportLoadingOrderDocument,
  IApiResponse,
  IUpdateLoadingOrderDocumentRequest,
} from "model";

export const prefix = "LOADING_ORDER";

export const getAllLoadingOrder = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<ILoadingOrder[]>
>(prefix, "GET_ALL_LOADING_ORDER");
export const getAllLoadingOrderProducts = ReduxHelper.generateActions<
  IGetLoadingOrderProductRequest,
  IPaginateApiResponse<ILoadingOrderProduct[]>
>(prefix, "GET_ALL_LOADING_ORDER_PRODUCTS");
export const getDeliveryProgress = ReduxHelper.generateActions<
  IGetDeliveryProgressRequest,
  IPaginateApiResponse<IDeliveryProgress[]>
>(prefix, "GET_ALL_DELIVERY_PROGRESS");
export const getAllLoadingOrderPallets = ReduxHelper.generateActions<
  IGetLoadingOrderPalletsRequest,
  IPaginateApiResponse<ILoadingOrderPallet[]>
>(prefix, "GET_ALL_LOADING_ORDER_PALLETS");
export const getRelatedDocuments = ReduxHelper.generateActions<
  IGetRelatedDocumentRequest,
  IPaginateApiResponse<IRelatedDocument[]>
>(prefix, "GET_RELATED_DOCUMENTS");
export const updateLODocument = ReduxHelper.generateActions<
  IUpdateLoadingOrderDocumentRequest,
  ILoadingOrder
>(prefix, "UPDATE_LO_DOCUMENT");
export const importLoadingOrderDocument = ReduxHelper.generateActions<
  IImportLoadingOrderDocument,
  any
>(prefix, "IMPORT_LOADING_ORDER_DOCUMENT");
